import { Box, Typography } from '@mui/material';
import { sdzColors } from 'core/constants/sdz.constants';
import { styles } from './data-zone-selector-helper';
import {
    DevZoneIcon,
    ProdZoneIcon,
    StageZoneIcon,
    UatZoneIcon,
} from '../../../assets';
import { CSSProperties } from 'react';

interface SdzMenuOptionProps {
    env: {
        realm: string;
        sdz: string;
    };
    isSelectField?: boolean;
    optionsTextStyles?: CSSProperties;
}

const getSdzIconStyle = (
    env: {
        realm: string;
        sdz: string;
    },
    isSelectField: boolean
): { [key: string]: string } => ({
    ...styles.sdzIcon,
    backgroundColor: sdzColors[env?.realm?.toLowerCase()]
        ? sdzColors[env?.realm?.toLowerCase()]
        : sdzColors.dev,
    ...(isSelectField && styles.sdzSelectIconStyles),
});

const getSdzIcon = (sdzRealm: string): string => {
    if (sdzRealm.toLowerCase() === 'stage') {
        return StageZoneIcon;
    } else if (sdzRealm.toLowerCase() === 'uat') {
        return UatZoneIcon;
    } else if (sdzRealm.toLowerCase() === 'prod') {
        return ProdZoneIcon;
    } else {
        return DevZoneIcon;
    }
};

export const SdzMenuOption = (props: SdzMenuOptionProps): React.JSX.Element => {
    const { env, isSelectField = false, optionsTextStyles } = props;
    return (
        <>
            <Box sx={getSdzIconStyle(env, isSelectField)}>
                <img
                    src={getSdzIcon(env?.realm)}
                    alt='sdz-icon'
                    style={isSelectField ? styles.sdzIconSelectFieldStyles : {}}
                />
            </Box>
            <Box sx={styles.sdzOptionContainer}>
                <Typography
                    sx={{ ...styles.sdzOptionText, ...optionsTextStyles }}
                >
                    {env?.sdz} ({env?.realm})
                </Typography>
            </Box>
        </>
    );
};
